import React, { useEffect, useState } from 'react'
import DataTable from 'react-data-table-component';
import HttpClient from '../../utils/HttpClient';
import CustomLoader from '../../CustomComponents/loader/CustomLoader';
import toast from 'react-hot-toast';
import NonMemberModal from '../../Component/Modal/NonMemberModal';
import moment from 'moment';
import EditDeleteIcon from '../../CustomComponents/EditDeleteIcon';
import * as XLSX from 'xlsx';
import { useNavigate } from 'react-router-dom';
import { saveAs } from 'file-saver';
import BusinessLIstingModal from '../../Component/Modal/BusinessLIstingModal';

const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "#868e96",
    margin: "11px",
    fontWeight: "bold"

}
const customStyles = {
    rows: {
        style: {
            minHeight: '48px', // override the row height
        },
    },
    headCells: {
        style: {
            paddingLeft: '8px', // override the cell padding for head cells
            paddingRight: '8px',
            backgroundColor: '#cee0eb', // set the background color for head cells
        },
    },
    cells: {
        style: {
            paddingLeft: '8px', // override the cell padding for data cells
            paddingRight: '8px',
        },
    },
};
const format1 = "DD-MM-YYYY, h:mm a"

const NonMember = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isBusinessModalOpen, setIsBusinessModalOpen] = useState(false);
    const [selectedDetails, setSelectedDetails] = useState("");
    const [AllData, setAllData] = useState([]);
    const [ExcelSheetData, setExcelSheetData] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    const [searchInput, setSearchInput] = useState('');
    const [filterCountryState, setfilterCountryState] = useState(false);
    const navigate = useNavigate()

    const columns = [
        {
            name: 'SL',
            selector: row => row.sl,
            width: "3.4rem"
        },
        {
            name: 'Customer#',
            selector: row => row.customerNo,
        },
        {
            name: 'View',

            cell: (row) => (
                <i className="fa-solid fa-eye " onClick={() => handleView(row.id)}
                    style={{ cursor: "pointer", color: 'darkBlue', fontSize: '15px' }}></i>
            ),
        },
        {
            name: 'Business Listing',

            cell: (row) => (
                <>
                    {
                        row.businessStatus && (
                            <>
                                <i className="fa-solid fa-eye " onClick={() => handleBusinessView(row.id)}
                                    style={{ cursor: "pointer", color: 'darkBlue', fontSize: '12px' }}></i>
                            </>
                        )
                    }
                </>
            ),

            width: "3.4rem",
            wrap: true,
        },
        {
            name: 'Company Type',
            selector: row => row.TypeOfCompany,
            width: "8.4rem",
            wrap: true
        },
        {
            name: 'Company Name',
            selector: row => row.companyName,
            width: "12.4rem",
            wrap: true
        },

        {
            name: 'Person Name',
            selector: row => row.personName,
            width: "12rem",
            wrap: true
        },
        {
            name: 'Designation',
            selector: row => row.designation,
            width: "7.6rem",
            wrap: true
        },
        {
            name: 'EmailId',
            selector: row => row.emailId,
            width: "9.4rem",
            wrap: true
        },
        // {
        //     name: 'telephoneNo',
        //     selector: row => row.telephoneNo,
        //     width: "6.2rem"
        // },
        {
            name: 'Mobile No',
            selector: row => row.mobileNo,
            width: "10.7rem"

        },
        {
            name: 'Directory',
            selector: row => row.directoryCount,
            width: "5.8rem"

        },


        // {
        //     name: 'whatsappNo',
        //     selector: row => row.whatsappNo,
        //     width: "6.5rem"
        // },

        // {
        //     name: 'websiteLink',
        //     selector: row => row.websiteLink,
        //     width: "10rem"
        // },
        // {
        //     name: 'address',
        //     selector: row => row.address,
        // },
        // {
        //     name: 'location',
        //     selector: row => row.location,
        //     width: "6.5rem"
        // },
        // {
        //     name: 'userName',
        //     selector: row => row.userName,
        // },

        // {
        //     name: 'dribbbleLink',
        //     selector: row => row.dribbbleLink,
        //     width: "8.5rem"
        // },
        // {
        //     name: 'facebookLink',
        //     selector: row => row.facebookLink,
        //     width: "8.5rem"
        // },
        // {
        //     name: 'instaLink',
        //     selector: row => row.instaLink,
        //     width: "8.5rem"
        // },
        // {
        //     name: 'linkedInLink',
        //     selector: row => row.linkedInLink,
        //     width: "8.5rem"
        // },

        // {
        //     name: 'Activation Code',
        //     selector: row => row.activationCode,
        //     width: "10.7rem"

        // },
        {
            name: 'Date & Time Created',
            selector: row => row.createdOn,
            width: "10.7rem"

        },
        {
            name: 'Activation Status',
            selector: row => row.loginStatus,
            width: "10.7rem"

        },

        {
            name: 'Status',
            selector: row => row.status,
            width: "10.7rem"

        },

        {
            name: 'Action',
            selector: row => row.action,
        },

        // {
        //     name: 'View',

        //     cell: (row) => (
        //         <i className="fa-solid fa-eye " onClick={() => handleView(row.id)}
        //             style={{ cursor: "pointer", color: 'darkBlue', fontSize: '15px' }}></i>
        //     ),
        // },
    ];

    const getCategoryWiseData = async () => {
        setIsLoading(true);
        const res = await HttpClient.requestData("non-member-user", "GET", {});
        let apiData = []
        if (res && res?.status) {
            setIsLoading(false);
            apiData = res?.data?.map((item, i) => ({
                id: item?._id,
                sl: i + 1,
                TypeOfCompany: item?.TypeOfCompany,
                companyName: item?.companyName,

                personName: item?.personName,
                designation: item?.designation,
                emailId: item?.emailId,

                phone_code: item?.phone_code,
                whats_code: item?.whats_code,

                mobileNo: item?.mobileNo,
                whatsappNo: item?.whatsappNo,
                directoryCount: item?.directoryCount,

                createdOn: moment(item?.createdOn).format(format1),
                businessStatus: item?.businessStatus,

                customerNo: item?.SLNo || "",

                ////
                telephoneNo:item?.telephoneNo,
                businessWebsiteLink:item?.businessWebsiteLink,
                webAddress:item?.webAddress,
                emirate:item?.emirate,
                countryName:item?.countryName,

                loginStatus: item?.loginStatus ? <button
                    onClick={() => handleLoginStatus(false, item?._id)}
                    type="button" className="btn btn-success floating-message px-3"
                    data-toggle="tooltip" data-placement="top" title="Click to Deactivate"
                    style={{ fontSize: "16px" }}>Active</button> : <button
                        onClick={() => handleLoginStatus(true, item?._id)}
                        type="button" className="btn btn-danger floating-message px-3"
                        data-toggle="tooltip" data-placement="top" title="Click to Activate">
                    Inactive
                </button>,



                status: <div>
                    {
                        item?.status === "Pending" ? <button
                            onClick={() => handleActive(item?._id)}
                            type="button" className="btn btn-danger floating-message px-3"
                            data-toggle="tooltip" data-placement="top" title="Click to Activate">
                            Pending
                        </button> : <button
                            onClick={() => handlePending(item?._id)}
                            type="button" className="btn btn-success floating-message px-3"
                            data-toggle="tooltip" data-placement="top" title="Click to Deactivate"
                            style={{ fontSize: "16px" }}>{item?.status}</button>
                    }
                </div>,
                action: <EditDeleteIcon

                    onClickEdit={(e) => handleEdit(item)}

                />,
                // action: <EditDeleteIcon

                //     onClickEdit={(e) => handleEdit(item)}
                //     onClickDelete={(e) => handleDelete(item?._id)}
                // />
            }));

        } else {
            setIsLoading(false);
        }
        // Filter data based on search input
        const filteredData = apiData?.filter(item =>
            item?.TypeOfCompany?.toLowerCase()?.includes(searchInput?.toLowerCase()) ||
            item?.companyName?.toLowerCase()?.includes(searchInput?.toLowerCase()) ||
            item?.personName?.toLowerCase()?.includes(searchInput?.toLowerCase()) ||
            item?.designation?.toLowerCase()?.includes(searchInput?.toLowerCase()) ||
            item?.emailId?.toLowerCase()?.includes(searchInput?.toLowerCase()) ||
            item?.mobileNo?.toString()?.includes(searchInput) ||
            item?.country?.toLowerCase()?.includes(searchInput?.toLowerCase()) ||
            item?.emirate?.toLowerCase()?.includes(searchInput?.toLowerCase()) ||
            item?.customerNo?.toString()?.toLowerCase()?.includes(searchInput?.toLowerCase())
        );
        // setAllData(filteredData.filter(item=>item.customerNo) );
        setAllData(filteredData);
        setExcelSheetData(filteredData.map(item => {
            const { status, action, loginStatus, ...rest } = item;
            return rest;
        }));
        // const filteredD = filteredData.filter(item => item.hasOwnProperty('status') && item.hasOwnProperty('action'));
    }

    //Activate
    const handlePending = async (id) => {
        setIsLoading(true);
        const data = {
            status: "Pending",
            // loginStatus:false
        }

        const res = await HttpClient.requestData(`activateUser/${id}`, "PUT", data);
        if (res && res?.status) {
            setIsLoading(false);
            toast.success("Status Deactivated Successfully");
            getCategoryWiseData();
        } else {
            setIsLoading(false);
        }
    }
    //Login Status
    const handleLoginStatus = async (val, id) => {
        // setIsLoading(true);
        const data = {
            loginStatus: val,
        }
        return

        const res = await HttpClient.requestData(`activateUser/${id}`, "PUT", data);
        if (res && res?.status) {
            setIsLoading(false);
            toast.success("Status Activated Successfully");
            getCategoryWiseData();
        }
    }
    //Pending
    const handleActive = async (id) => {
        setIsLoading(true);
        const data = {
            status: "Active",
            loginStatus: true
        }

        const res = await HttpClient.requestData(`activateUser/${id}`, "PUT", data);
        if (res && res?.status) {
            setIsLoading(false);
            toast.success("Status Activated Successfully");
            getCategoryWiseData();
        }
    }
    //MODAL VIEW
    const handleView = async (id) => {

        setSelectedDetails(id);
        setIsModalOpen(true);
    }
    //BUSINESS MODAL VIEW
    const handleBusinessView = async (id) => {

        setSelectedDetails(id);
        setIsBusinessModalOpen(true);
    }
    //edit
    const handleEdit = (item) => {
        navigate("/non-member-edit", { state: item })
    }
    // Function to export data to Excel
    // const exportToExcel = () => {
    //     const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    //     const fileExtension = '.xlsx';
    //     const fileName = 'users_data';

    //     const ws = XLSX.utils.json_to_sheet(ExcelSheetData);
    //     const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    //     const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    //     const data = new Blob([excelBuffer], { type: fileType });
    //     saveAs(data, fileName + fileExtension);
    // };


    const exportToExcel = () => {
        const fileType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        const fileExtension = ".xlsx";
        const fileName = "nonmembers_data";

        const exportMembers = ExcelSheetData.map((item, idx) => ({
            customerNo: item.customerNo || "",
            companyName: item.companyName || "",
            typeOfBusiness: item.TypeOfCompany || "",
            personName: item.personName || "",
            designation: item.designation || "",
            emailId: item.emailId || "",
            contactNumber: item.phone_code ? `${item.phone_code}${item.telephoneNo}` : item.telephoneNo,
            contactNumber2: item.phone_code ? `${item.phone_code}${item.mobileNo}` : item.mobileNo,
            website:item.businessWebsiteLink ||item.webAddress,
            state:item.emirate,
            country:item.countryName

            // directoryCount: Number(item.directoryCount) || 0,
            // businessStatus: Boolean(item.businessStatus),
            // fullMobile: item.phone_code ? `${item.phone_code}${item.mobileNo}` : item.mobileNo,
        }));

        const headerMap = {
            customerNo: "Customer ID",
            companyName: "Company Name",
            typeOfBusiness: "Type Of Business",
            personName:"Person Name",
            designation: "Designation",
            emailId:"Email Id",
            contactNumber:"Contact Number",
            contactNumber2:"Contact Number 2",
            website:"Website",
            state:"State",
            country:"Country"
        };

        const fields = Object.keys(headerMap);
        const dataWithHeaders = exportMembers.map((row) =>
            fields.map((field) => row[field])
        );

        dataWithHeaders.unshift(Object.values(headerMap));

        const ws = XLSX.utils.aoa_to_sheet(dataWithHeaders);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

        const data = new Blob([excelBuffer], { type: fileType });
        saveAs(data, fileName + fileExtension);
    };



    useEffect(() => {
        getCategoryWiseData();
    }, [searchInput])
    return (
        <div className="d-flex justify-content-end">
            <div className="form-header">

                <CustomLoader loading={isLoading} />
                <section className="piechartsBox_area">
                    <div
                        style={headLineStyle}
                        className="page-headline"
                    >
                        NON MEMBERS
                    </div>
                    <div className=" d-flex justify-content-between  mb-2" >
                        {/* filter by country and state */}
                        {!filterCountryState &&
                            <div className="d-flex flex-column  justify-content-between  mt-3" >
                                {/* <div className='mb-2'>
                                    <label htmlFor="formGroupExampleInput">Country<span className="text-danger">&nbsp;</span></label>
                                    <select class="hello">
                                        <option selected value="0">Pure CSS Select</option>
                                        <option value="1">No Wrapper</option>
                                        <option value="2">No JS</option>
                                        <option value="3">Nice!</option>
                                    </select>
                                </div>
                                <div>
                                    <label htmlFor="formGroupExampleInput">Emirate <span className="text-danger">&nbsp;</span></label>
                                    <select class="hello">
                                        <option selected value="0">Pure CSS Select</option>
                                        <option value="1">No Wrapper</option>
                                        <option value="2">No JS</option>
                                        <option value="3">Nice!</option>
                                    </select>
                                </div> */}
                            </div>}
                        <div className="Search_box">
                            <form className="form-inline">
                                <input
                                    className="form-control h-75"
                                    type="search"
                                    placeholder="Search"
                                    aria-label="Search"
                                    value={searchInput}
                                    onChange={(e) => setSearchInput(e.target.value)}
                                />
                                <div className="Search_icon">
                                    <i className="fa-solid fa-magnifying-glass"></i>
                                </div>
                            </form>
                            <div className="d-flex justify-content-end">
                                {/* Your existing JSX code */}
                                <button className="btn btn-primary" onClick={exportToExcel}>Export to Excel</button>
                                {/* Your existing JSX code */}
                            </div>
                        </div>
                    </div>


                    <form>

                        <div>

                            <DataTable
                                columns={columns}
                                data={AllData}
                                pagination
                                striped
                                className=" rounded "
                                customStyles={customStyles}
                            />
                        </div>
                    </form>
                </section>
                <NonMemberModal
                    isOpen={isModalOpen}
                    closeModal={() => setIsModalOpen(false)}
                    details={selectedDetails}
                />
                <BusinessLIstingModal
                    isOpen={isBusinessModalOpen}
                    closeModal={() => setIsBusinessModalOpen(false)}
                    details={selectedDetails}
                />
            </div>

        </div>
    )
}

export default NonMember